import { useLocation, useParams, Link } from "react-router-dom";

const WHATSAPP_NUMBER = "60195960498";

interface SummaryState {
  reference: string;
  total_cents: number;
  nights: number;
  expires_at: string;
  checkin: string;
  checkout: string;
}

export default function BookingSummary() {
  const { ref } = useParams();
  const location = useLocation();
  const state = location.state as SummaryState | undefined;

  if (!state) {
    // Page was opened directly (e.g. bookmarked) without the in-memory state from
    // just-created booking — send them to the lookup page instead of guessing.
    return (
      <div className="max-w-lg mx-auto px-6 py-16 text-center">
        <p className="text-sea-700 mb-4">
          Untuk menyemak tempahan sedia ada, sila gunakan halaman semakan status.
        </p>
        <Link to="/semakan" className="text-sea-500 underline">
          Ke Halaman Semakan Status
        </Link>
      </div>
    );
  }

  const whatsappMsg = encodeURIComponent(
    `Hai, saya baru buat tempahan Rumah Pantai Homestay.\nRujukan: ${ref}\nSaya lampirkan resit pembayaran.`
  );

  return (
    <div className="max-w-lg mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold text-sea-700 mb-1">Tempahan Diterima</h1>
      <p className="text-sea-500 mb-6">Rujukan: <span className="font-mono font-bold">{ref}</span></p>

      <div className="bg-white rounded-xl shadow-sm p-6 space-y-2 text-sm mb-6">
        <p><strong>Tarikh:</strong> {state.checkin} — {state.checkout} ({state.nights} malam)</p>
        <p><strong>Jumlah:</strong> RM{(state.total_cents / 100).toFixed(2)}</p>
        <p className="text-red-600">
          Tarikh ditahan sehingga <strong>{new Date(state.expires_at).toLocaleString("ms-MY")}</strong> — sila selesaikan pembayaran sebelum tamat tempoh.
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-6 text-center mb-6">
        <p className="font-medium mb-3">Imbas untuk bayar melalui DuitNow QR</p>
        <img src="/images/duitnow-qr.png" alt="DuitNow QR" className="mx-auto w-56" />
        <p className="text-xs text-sea-500 mt-2">
          Selepas membayar, sila hantar resit melalui WhatsApp supaya kami boleh sahkan tempahan anda.
        </p>
      </div>

      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-center bg-green-500 text-white rounded-lg py-3 font-medium hover:bg-green-600 transition mb-3"
      >
        Hantar Resit via WhatsApp
      </a>

      <Link to="/semakan" className="block text-center text-sea-500 underline text-sm">
        Semak status tempahan kemudian
      </Link>
    </div>
  );
}
